<template>
  <div class="help-center__cards">
    <h2 class="help-center__title">
      <img
        src="/static/images/icon-help-basic-purple.svg"
        alt="icone-download"
      >
      <span>Ajuda básica</span>
      <p>Vídeos informativos, tutoriais e documentos:</p>
    </h2>
    <div class="help-center__cards-wrapper">
      <div
        v-for="card in content"
        :key="card.id"
      >
        <template v-if="!card.featureToggle | (toggle[card.featureToggle] === true)">
          <div
            class="help-center__card"
            @click="handleAction(card)"
          >
            <h3 class="help-center__card-title">
              {{ card.title }}
            </h3>
            <p class="help-center__card-subtitle">
              {{ card.subtitle }}
            </p>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Moment from 'moment'

export default {
  name: 'HelpCenterCards',
  data: () => ({
    content: [
      {
        id: 1,
        featureToggle: false,
        title: 'Como usar o AOL 2.0',
        subtitle: 'Vídeo informativo',
        action: 'video'
      },
      {
        id: 2,
        featureToggle: false,
        title: 'Impressão de etiquetas',
        subtitle: 'Tutorial',
        action: 'tutorial-impressao',
        link: 'https://storageapoiob2bprd.blob.core.windows.net/utils/Apoio - tutorial loteamento WS v2.pdf'
      },
      {
        id: 3,
        featureToggle: false,
        title: 'Rastreabilidade de amostras',
        subtitle: 'Tutorial',
        action: 'tutorial-rastreabilidade',
        link: 'https://storageapoiob2bprd.blob.core.windows.net/utils/rastreabilidade_v2.pdf'
      },
      {
        id: 4,
        featureToggle: false,
        title: 'Cartilha operacional',
        subtitle: 'Documento',
        action: 'cartilha',
        link: 'https://storageapoiob2bprd.blob.core.windows.net/utils/Alvaro-Apoio-Cartilha-Operacional_v2.pdf'
      },
      {
        id: 5,
        featureToggle: false,
        title: 'Tour pela tela inicial',
        subtitle: 'Tutorial',
        action: 'tutorial-home'
      },
      {
        id: 6,
        featureToggle: 'webPrinting',
        title: 'Nova impressão de etiquetas',
        subtitle: 'Documento',
        action: 'new-print-mode',
        link: 'https://storageapoiob2bprd.blob.core.windows.net/aol-downloads/Apoio%20Novo%20Servi%C3%A7o%20Impressao.pdf'
      }
    ]
  }),
  computed: {
    ...mapGetters(['profile', 'toggle']),
    today() {
      return Moment(new Date()).format('DD/MM/YYYY')
    }
  },
  methods: {
    ...mapActions(['resetTutorial']),
    pushEventToAnalytics(action) {
      this.$analytics.pushAnalyticsEvent('ga-event', {
        category: 'Central de Ajuda',
        action: action,
        'id-user': this.profile.id,
        'id-lab': this.profile.id_laboratory,
        'name-lab': this.profile.laboratoryName
      })
    },
    handleAction(card) {
      switch (card.action) {
        case 'video':
          this.$emit('openVideo')
          this.pushEventToAnalytics('Ajuda básica - Como usar o AOL 2.0')
          break
        case 'tutorial-impressao':
          window.open(card.link, '_blank')
          this.pushEventToAnalytics('Ajuda básica - Impressão de etiquetas')
          break
        case 'tutorial-rastreabilidade':
          window.open(card.link, '_blank')
          this.pushEventToAnalytics('Ajuda básica - Rastreabilidade de amostras')
          break
        case 'cartilha':
          window.open(card.link, '_blank')
          this.pushEventToAnalytics('Ajuda básica - Cartilha operacional')
          break
        case 'new-print-mode':
          window.open(card.link, '_blank')
          this.pushEventToAnalytics('Ajuda básica - Nova impressão de etiquetas')
        case 'tutorial-home':
          this.resetTutorial()
          this.pushEventToAnalytics('Ajuda básica - Tour pela tela inicial')
          localStorage.removeItem('visualized')

          setTimeout(() => {
            window.location = '/'
          }, 600)
          break
      }
    }
  }
}
</script>

<style lang="scss">
.help-center {
  font-family: 'Exo 2' !important;

  &__title {
    color: #6d6d6d;
    font-weight: 700;
  }

  &__card-title {
    font-weight: 700;
    font-size: 18px;
    color: #7f1a54;
    margin-bottom: 5px;
  }
  &__card-subtitle {
    font-weight: normal;
    font-size: 11px;
    line-height: 13px;
    letter-spacing: 2px;
    text-transform: uppercase;

    color: #7a7a7a;
  }

  &__card {
    cursor: pointer;
    background-image: url('/static/images/bg-card-help.svg');
    background-repeat: no-repeat;
    background-color: #fff;
    border-radius: 5px;
    padding: 30px 13px;
    background-size: contain;
    background-position: calc(100% + 30px);
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.12);
    position: relative;
    transition: all ease-in-out 0.2s;
    overflow: hidden;

    &:hover {
      background-position: 100%;
    }
  }

  &__cards-wrapper {
    display: flex;
    flex-wrap: wrap;
    > div {
      width: calc(50% - 15px);
      margin-bottom: 20px;
      &:nth-child(odd) {
        margin-right: 30px;
      }
    }
  }
}
</style>
